export const permitsList = {
  ADMIN_JEFES: 6,
  ADMIN_USUARIOS: 2,
  ADMIN_PERMISOS: 3,
  ADMIN_GERENTES: 4,
  ADMIN_GERENTES_JEFES: 5,
  ADMIN_JEFES_TERRITORIOS: 7,
  ADMIN_MUNICIPIOS_ZONAS: 8,
  ADMIN_TERRITORIOS: 9,
  ADMIN_TERRITORIOS_ZONAS: 10,
  ADMIN_ZONAS: 11,
  MUNICIPIOS_CALCULOS: 12,
  SEGMENTACION_CATEGORIAS: 13,
  SEGMENTACION_LINEAS: 14,
  SEGMENTACION_LINEAS_ALIAS: 15,
  SEGMENTACION_MAESTROS_PRECIOS: 16,
  SEGMENTACION_MAESTROS_SEGMENTOS: 17,
  SEGMENTACION_MAESTROS_TERRITORIOS: 18,
  SEGMENTACION_MARCAS: 19,
  SEGMENTACION_MARCAS_ALIAS: 20,
  SEGMENTACION_SEGMENTOS: 21,
  SEGMENTACION_SUBCATEGORIAS: 22,
  SEGMENTACION_SUBSEGMENTOS: 23,
  REPORTE_PROVEEDORES_MOTOCICLETAS: 24,
  REPORTE_PROVEEDORES_3W: 25,
  PROYECCION_INDUSTRIA: 26,
  PROYECCION_LANZAMIENTO: 27,
  REPORTE_DATASTUDIO: 28,
  REPORTE_MOBILITY: 29,
  REPORTE_PROVEEDORES: 30,
  SEGMENTACION_4W: 31,
  BUSCADOR_USUARIOS: 32,
  PRESUPUESTOS_COMERCIALES: 33,
  FACTURAS_CLASES: 35,
  GLULY: 36,
  YOUTUBE: 37,
  SALES_MANAGO: 38,
  LANZAMIENTOS_REPORTES: 39,
  INDICADORES_IPC: 40,
  MAP_CONECTION: 41,
  VALUE_MAP: 42,
  BOARD_REPORTS: 43,
  LANZAMIENTOS_ALTA_GAMA: 44,
  ADMIN_USER_INVENTARIO: 45,
  LEADS_ADMIN: 46,
  LEADS_JEFE_COMERCIAL: 47,
  FABRICA_INSIGHTS: 48,
  ADMIN_SOLICITUD_REPORTE_DATASTUDIO: 49,
  ADMIN_SOLICITUD_PERMISO_REPORTE_DATASTUDIO: 50,
  GLUKY_SEARCH_POINTS: 51,
  MASTER_M2: 52,
  POSTVENTA_BUSCADOR: 53,
  MOTOMAX_BUSCADOR: 54,
  SEGMENTACION_CANALES: 55,
  TABLERO_BEACONS: 56,
  REPUESTOS_INFORMES: 57,
  GVC_ADMIN: 58,
  AUTECO_BLUE: 59,
  GVC_ACTIONS: 60,
  GVC_CONFIG: 61,
  TRAKKU: 62,
  COMERCIAL_BLUE: 63,
  FACTURACION: 65,
  BUSCADOR_PQRS: 66,
  PDF: 100,
  SNOP: 64,
  TORRE: 67,
  COMERCIAL: 68,
  SOSTENIBILIDAD: 72,
  TOM: 74,
  BUSQUEDA_IA: 75,
  RUTA_AUTECO: 76,
  IA_GENERATIVA: 77,
  MOTOS_SYOP: 78,
  NITROPIXEL_PRO: 79,
  AERCORSOFT: 80,
  AXIOMA_AUDITOR: 81,
  AXIOMA_AXIOMER: 82,
  AXIOMA_JERARQUIAS: 83,
  RUTA_SEGURA: 84,
  AXIOMA_ESCANER: 99,
  PRECIOS: 90,
  PRECIOS_TRADE: 91,
  PRECIOS_BACKCOMERCIAL: 92,
  PRECIOS_IA_VICTORY: 93,
  PRECIOS_IA_TVS: 94,
  PRECIOS_IMPULSA: 95,
  PRECIOS_PROMOS: 96,
  PRECIOS_ADMIN: 97,
  PRECIOS_ECOMMERCE: 98,
}

export const minPermisos = {
  ABIERTO: 0,
  VISUALIZAR: 1,
  CREAR: 2,
  ACTUALIZAR: 3,
  ELIMINAR: 4,
  ADMINISTATIVO: 5,
}
